import { render, staticRenderFns } from "./BrandingCategory.vue?vue&type=template&id=b1b72d80&"
import script from "./BrandingCategory.vue?vue&type=script&lang=ts&"
export * from "./BrandingCategory.vue?vue&type=script&lang=ts&"
import style0 from "./BrandingCategory.vue?vue&type=style&index=0&id=b1b72d80&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports